import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'patient-portal-lab-result-history',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['userId'],
    },
    'ccd',
    'historic_lab_results',
    {
      type: 'payload.query',
      selector: ['componentCode'],
      queryParameter: 'component_code',
    },
    {
      type: 'payload.query',
      selector: ['limit'],
      queryParameter: 'limit',
    },
    {
      type: 'payload.query',
      selector: ['startTime'],
      queryParameter: 'start_time',
    },
    {
      type: 'payload.query',
      selector: ['endTime'],
      queryParameter: 'end_time',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/lab-result-history-req.js